import { FC } from 'react';

import { CountryEntity } from 'api/types/entity';
import { isFinanceProject, isGlobalProject } from 'config';
import { useFormErrorFocus } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  CitizenshipSection,
  PepConnectionSection,
  TaxResidencySection,
  ReasonAddSection,
  PlaceOfBirthAndRegistrationAddressSection,
  PlaceOfBirthAndResidentialAddressSection,
} from 'modules/client/common/components/sections';
import {
  CountryRiskProvider,
  CountryRiskRole,
} from 'modules/client/common/feature';
import { ControlOverSection } from 'modules/client/legalClientBeneficiary/components/sections';

import { PersonalDataSection } from '../sections';

export interface LegalClientAddBeneficiarySectionsProps {
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const LegalClientAddBeneficiarySections: FC<
  LegalClientAddBeneficiarySectionsProps
> = ({ countries, countriesLoading }) => {
  useFormErrorFocus();

  const { t } = useTranslation();

  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();

  return (
    <CountryRiskProvider role={CountryRiskRole.LegalClientBeneficiary}>
      <Stack spacing={24}>
        <ReasonAddSection />
        <PersonalDataSection />
        {isGlobal && (
          <ControlOverSection
            enabledControlOverLegalClientStatus
            enabledFinancialConditionAmount={false}
            enabledHasControlOverLegalClient={false}
          />
        )}
        <CitizenshipSection
          countries={countries}
          countriesLoading={countriesLoading}
        />
        <TaxResidencySection
          countries={countries}
          countriesLoading={countriesLoading}
        />
        {isFinance && (
          <PlaceOfBirthAndRegistrationAddressSection
            countries={countries}
            countriesLoading={countriesLoading}
          />
        )}
        {isGlobal && (
          <PlaceOfBirthAndResidentialAddressSection
            countries={countries}
            countriesLoading={countriesLoading}
          />
        )}
        <PepConnectionSection
          notRequestInformation={isGlobal}
          pepConnectionRelationLabel={t(
            'client.legal.legalClientBeneficiary.pepConnection.relation.label'
          )}
        />
        {isFinance && (
          <ControlOverSection
            enabledFinancialConditionAmount
            enabledHasControlOverLegalClient
            enabledControlOverLegalClientStatus={false}
          />
        )}
      </Stack>
    </CountryRiskProvider>
  );
};
